import type { ComponentProps } from "react";

import { cn } from "../lib/utils";

function Skeleton({ className, ...props }: ComponentProps<"span">) {
  return (
    <span className={cn("bg-primary/10 block animate-pulse rounded-md", className)} data-slot="skeleton" {...props} />
  );
}

export { Skeleton };
